import { Grid } from "@material-ui/core";
import React, { useContext, useState } from "react";

import DataTable from "../../ui/DataTable/DataTable";

import CustomDialog from "../../ui/CustomDialog/CustomDialog";

import { AuthContext } from "../../context/AuthContext/AuthContext";
import { ClientContext } from "../../context/ClientContext/ClientContext";

import ClientForm from "../ClientForm";

export default function ClientTable() {
  const { clients, loading, setSelectedClient, getClientDataAll } = useContext(ClientContext)
  const { updateUserAuthByAdmin, deleteUserAuthByAdmin } = useContext(AuthContext)

  const [showModal, setShowModal] = useState(false);

  const handleEditAction = (rowData) => {
    setSelectedClient(rowData)
    setShowModal(true);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12} lg={12}>
        <DataTable
          search={false}
          isLoading={loading}
          grouping={true}
          exportButton={true}
          paging={true}
          title={'Clients'}
          columns={[
            { title: "Name", field: "name" },
            { title: "Email", field: "email" },
            { title: "Address", field: "address" },
            { title: "Phone Number", field: "phoneNumber" },
            { title: "Created By", field: "createdBy.name" },
            { title: "Modified By", field: "modifiedBy.name" },
          ]}
          data={clients ? clients : []}
          editable={{
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                resolve();
                deleteUserAuthByAdmin(oldData.id);
                getClientDataAll()
              }),
          }}
          actions={[
            {
              icon: "edit",
              tooltip: "Edit Client",

              onClick: (event, rowData) => handleEditAction(rowData),
            },
            {
              icon: "block",
              tooltip: "Disable User",
              onClick: (event, rowData) => {
                updateUserAuthByAdmin(rowData.id, { disabled: true });
              },
            },
            {
              icon: "vpn_key",
              tooltip: "Enable User",
              onClick: (event, rowData) => {
                updateUserAuthByAdmin(rowData.id, { disabled: false });
              },
            },
            {
              icon: "lock_open",
              tooltip: "Reset password",
              onClick: (event, rowData) => {
                updateUserAuthByAdmin(rowData.id, {
                  password: rowData.phoneNumber,
                });
              },
            },
          ]}
        />
      </Grid>

      {/* showModal */}
      <CustomDialog
        maxWidth={"md"}
        title={"Edit Client"}
        buttonCaption="Edit"
        open={showModal}
        setOpen={setShowModal}
      >
        <ClientForm
          setOpen={setShowModal}
          action={1}
        />
      </CustomDialog>
    </Grid>
  );
}
